import type {
    IDigitalGiftSkusInput,
    IDigitalGiftAddOutput,
    IDigitalGiftAddToWalletInput,
    IDigitalGiftAddToWalletOutput,
    IDigitalGiftHistoryResponse,
    IDigitalGiftResendInput,
    IDigitalGiftDownloadPdfInput
} from "@types";
import gate from "../gate";
import client, { fileDownloadClient } from "../http-clients/api";

const DigitalGiftApi = {
    getSkus: () =>
        gate.get<IDigitalGiftSkusInput, never, never>({
            client,
            url: "digitalGift/skus",
        }),

    addDigitalGift: (data: IDigitalGiftAddOutput) =>
        gate.post<any, IDigitalGiftAddOutput, never>({
            client,
            url: "digitalGift/addDigitalGift",
            data,
        }),

    addDigitalGiftToWallet: (data: IDigitalGiftAddToWalletOutput) =>
        gate.post<IDigitalGiftAddToWalletInput, IDigitalGiftAddToWalletOutput, never>({
            client,
            url: "digitalGift/addDigitalGiftToWallet",
            data,
        }),
    getHistory: () =>
        gate.get<IDigitalGiftHistoryResponse, never, never>({
            client,
            url: "digitalGift/history",
        }),

    resendDigitalGift: (digital_gift_id: number, sendByWhatsApp?: IDigitalGiftResendInput["sendByWhatsApp"]) =>
        gate.get<any, never, IDigitalGiftResendInput>({
            client,
            url: `digitalGift/resendDigitalGift`,
            params: {
                digital_gift_id,
                sendByWhatsApp,
            },
        }),

    downloadPdf: (order_id?: string, digital_gift_id?: string) =>
        gate.get<Blob, never, IDigitalGiftDownloadPdfInput>({
            client: fileDownloadClient,
            url: `digitalGift/${order_id || digital_gift_id}/downloadPdf`,
            params: {
                type: digital_gift_id ? "digital_gift" : undefined,
            },
        }),
};

export default DigitalGiftApi; 